<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.8 20C6.37 20 5.213 21.125 5.213 22.5C5.213 23.875 6.37 25 7.8 25C9.23 25 10.4 23.875 10.4 22.5C10.4 21.125 9.23 20 7.8 20ZM0 0V2.5H2.6L7.28 11.9875L5.525 15.05C5.317 15.4 5.2 15.8125 5.2 16.25C5.2 17.625 6.37 18.75 7.8 18.75H23.4V16.25H8.346C8.164 16.25 8.021 16.1125 8.021 15.9375L8.06 15.7875L9.23 13.75H18.915C19.89 13.75 20.748 13.2375 21.19 12.4625L25.844 4.35C25.948 4.175 26 3.9625 26 3.75C26 3.0625 25.415 2.5 24.7 2.5H5.473L4.251 0H0ZM20.8 20C19.37 20 18.213 21.125 18.213 22.5C18.213 23.875 19.37 25 20.8 25C22.23 25 23.4 23.875 23.4 22.5C23.4 21.125 22.23 20 20.8 20Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCategory',
  props: {
    width: {
      type: Number,
      default: 23,
    },
    height: {
      type: Number,
      default: 23,
    },
    fill: {
      type: String,
      default: '#495057',
    },
  },
};
</script>

<style scoped>
</style>